/**
 * Scene component extracted from ShortMetaScene
 */

class ShortMetaSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setBundles(this.listBundles());
    }

    onTransitionAnimationDidStart() {
        this.progressView.hide();
        return true;
    }

    buildProgressView() {
        this.progressView = new ShortMetaProgressView();
        return this.progressView;
    }

    buildPlayButton() {
        return new PlayButtonView();
    }

    isKnockoutGame() {
        return cleverapps.isKnockoutGame();
    }

    buildTable() {
        this.table = new WeeklyCupView();
        return this.table;
    }

    getBackgroundStyles() {
        const bundleName = "backgrounds_main";
        let imageName = "background_image";

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL && bundles[bundleName].urls.background_image_vertical) {
            imageName = "background_image_vertical";
        }

        return {
            bundle: bundleName,
            backgroundId: imageName,
            animation: bundles.backgrounds_main.jsons.background_animation
        };
    }

    listBundles() {
        return ["main", "dialogues"];
    }
}

Prefab.registerComponent("ShortMetaSceneComponent", ShortMetaSceneComponent);
